import _ from 'lodash';

export const getAvailablePlates = function (plateConfig) {
  const availablePlates = [];
  _.each(plateConfig, function (plate) {
    const platePairs = plate.pairsCount;
    _.times(platePairs, function() {
      availablePlates.push(plate);
    });
  });
  return availablePlates;
};

const calculatePlates = function (weight, availablePlates) {
  if(!weight) {
    return [];
  }

  // all remainingplates that are less than or equal to weight needed.
  const usablePlates = _.filter(availablePlates, (plate) => {
    return plate.weight <= weight;
  });

  const largestUsablePlate = _.maxBy(usablePlates, 'weight');

  if(largestUsablePlate) {
    _.pullAt(usablePlates, _.findIndex(usablePlates, {weight: largestUsablePlate.weight}));
    const remainingWeight = weight - largestUsablePlate.weight;
    return [largestUsablePlate].concat(calculatePlates(remainingWeight, usablePlates));
  } else {
    throw new Error('Cannot calculate correct combination of plates');
  }
};

export const getPlates = function (weight, availablePlates, platform) {
  const barAndCollarsWeight = _.get(platform, 'barAndCollarsWeight', 25); // kg
  const halfRemainingWeight = (weight - barAndCollarsWeight) / 2;

  return calculatePlates(halfRemainingWeight, availablePlates);
};
